var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#272726",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92 12.195a6.09 6.09 0 0 1-6.083-6.083A6.09 6.09 0 0 1 9.92.03a6.09 6.09 0 0 1 6.083 6.082 6.09 6.09 0 0 1-6.083 6.083zm0-10.206a4.127 4.127 0 0 0-4.123 4.123 4.128 4.128 0 0 0 4.122 4.124 4.128 4.128 0 0 0 4.124-4.124A4.128 4.128 0 0 0 9.919 1.99zM13.72 25.195H6.12a6.09 6.09 0 0 1-6.083-6.083A6.09 6.09 0 0 1 6.12 13.03h7.602a6.09 6.09 0 0 1 6.082 6.082 6.09 6.09 0 0 1-6.082 6.083zM6.12 14.989a4.127 4.127 0 0 0-4.123 4.123 4.127 4.127 0 0 0 4.123 4.123h7.602a4.127 4.127 0 0 0 4.123-4.123 4.127 4.127 0 0 0-4.123-4.123H6.119z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.84f5924afa53804dd7338031e8fa5ce1.svg";
export { ForwardRef as ReactComponent };